<template>
  <div>
    <b-modal 
      centered 
      id="ModalCustomCoverages" 
      size="lg"
      modal-class="custom-dialog dialog-700"
      hide-footer
      :title="$t(data.isNew ? 'Nueva tarifa propia' : 'Editar tarifa propia')"
      @close="close"
      no-close-on-esc
      no-close-on-backdrop
      ref="ModalCustomCoverages"
    >
      <form-render :form.sync="form" :fields="fields" ref="formRenderCustomCoverages" containerButtonsClass="col-sm-4 mt-2" :key="keyFormRender" >
        <template #msg="scope"><ul class="msg-custom-coverage mb-2"><li>{{ scope.field.msg }}</li></ul></template>
        <template #applicationTags>
          <b-badge class="badge__cnt" v-for="(data, index) in valueTags" :key="`${index}_valueTags`" disabled>{{data.text}}
            <b-button variant="outline" class="border-0" size="sm" @click="removeTagApplication(index)" :disabled="!data.isNew">
              <feather-icon icon="XIcon" size="20"  class="warning color_icon"/>
            </b-button>
          </b-badge>
        </template>
        <template #labelFieldFile>
          <label>Archivo de importación </label>
          <span class="text-danger">{{data.isNew ? ' *' : ''}}</span>
          <b-button size="sm" variant="link" @click="openModal" :disabled="!(form.country)">( Descargar Formatos )</b-button>
        </template>
      </form-render>
      <div class="footer-modal-custom-coverage">
        <b-button class="float-right mt-1 mb-1" variant="outline-success" @click="ok" :disabled="loading.updatingData">
          <span v-if="!loading.updatingData" class="mb-1">{{data.isNew ? 'Crear Tarifa' : 'Actualizar Tarifa'}}</span>
          <span class="mt-1 p-2" v-if="loading.updatingData"><b-spinner small  /> </span>
        </b-button>
      </div>
    </b-modal>
    <ModalDownLoadFormats ref="ModalDownLoadFormats" :data="{form: form}" v-if="isOpenModalDownLoadFormats"></ModalDownLoadFormats>
  </div>
</template>

<script>
import BaseServices from '@/store/services/index'
import { mapGetters } from 'vuex'
import ModalDownLoadFormats from './ModalDownLoadFormats.vue'

export default {
  name: 'ModalCustomCoverages',
  props: ['data', 'hideModal', 'getRates'],
  components: { ModalDownLoadFormats },
  data() {
    return {
      ModalCustomCoverages: 0,
      form: {switchActive: true},
      fields: [],
      keyFormRender: 0,
      baseService: new BaseServices(this),
      loading: { updatingData: false },
      switchActive : { fieldType: 'FieldCheckbox', switchActive: true, name: 'switchActive', options: [{id: 1, text: 'Activa'}], containerClass: 'col-12 container-info custom-switch-success', change: this.changeSwitchActive },
      msgNewTariff: { name: 'msg', msg: 'Se creará la tarifa activa por defecto. Haga click en el switch si desea crearla inactiva para activarla más tarde.', useLabel: false, useSlot: true, containerClass: 'col-12 p-0' },
      msgEditTariff: { name: 'msg', msg: 'Es posible editar el estado, días de preparación, archivo de importación e iva.', useLabel: false, useSlot: true, containerClass: 'col-12 p-0' },
      fieldCountry: { fieldType: 'FieldSelect', useLabel: true, name: 'country', label: 'País', validation: 'required', containerClass: 'col-12 container-info', change: this.changeCountry, addFlags: true, sort: true, options: this.data?.countries || [] },
      fieldIdSeller: { fieldType: 'FieldSelect', name: 'seller', useSkeleton: false, useLabel: true, label: 'ID/Nombre empresa o mkp', validation: 'required', containerClass: 'col-12 container-info', dependency: 'country', clearable: true, change: this.changeSeller, placeholder: 'Seleccione ID/Nombre empresa o mkp', searchOnType: { fx: this.setSeller, nChars: 2, debounce: 600 } },
      fieldApplication: { fieldType: 'FieldSelect', name: 'application', useSkeleton: false, useLabel: true, label: 'Nombre Aplicación', validation: 'required', containerClass: 'col-12 fieldSelect', dependency: 'seller', clearable: true, change: this.changeApplication, sort: true },
      fieldApplicationTags: { name: 'applicationTags', useSlot: true, containerClass: 'col-12' },
      fieldCheckboxApplyAllApplications : { fieldType: 'FieldCheckbox', name: 'allApplications', options: [{id: 1, text: 'Aplicar a todos los aplicaciones disponibles'}], containerClass: 'col-12 container-info mt-1', change: this.changeApplyAllApplications, dependency: 'country' },
      fieldpreparationDays: { fieldType: 'FieldInput', name: 'preparationDays', label: 'Días de preparación', type: 'number', containerClass: 'col-sm-12 container-info', validation: 'required' },
      labelFieldFile: { name: 'labelFieldFile', useSlot: true, containerClass: 'col-12' },
      fieldFile: { fieldType: 'FieldFileDropArea', name:'file', labelFormFile: 'Subir Tarifa', containerClass: 'col-12 container-info', accept: '.xlsx', classField:'hide-button-browse', clearable: true, validation: 'required' },
      fieldCheckboxIva : { fieldType: 'FieldCheckbox', name: 'checkboxIva', options: [{id: 1, text: 'Añadir Iva'}], containerClass: 'col-12 container-info', dependency: 'country', change: this.changeCheckboxIva },
      fieldIva: { fieldType: 'FieldInput', name: 'iva', containerClass: 'col-2 container-info', disabled: true },
      msgIva: { name: 'msg', msg: 'nota: si selecciona Añadir Iva, se sumará el porcentaje de iva a la tarifa cargada.', useLabel: false, useSlot: true, containerClass: 'col-sm-12 col-md-12 col-lg-12', dependency: 'country' },
      valueTags: [],
      url: 'https://www.google.com',
      ivaValue: {
        CL: '19%',
        CO: '19%',
        MX: '16%',
        PE: '18%'
      },
      isOpenModalDownLoadFormats: false
    }
  },
  computed: {
    ...mapGetters({
      applications: 'getApplications'
    })
  },
  watch: {
    applications() {
      this.setOptions(this.fields, 'application', this.applications.rows)
    }
  },
  methods: {
    setInitialData() {
      if (this.data.session.role === 'admin') {
        this.fields = [
          this.switchActive,
          this.fieldCountry,
          this.fieldIdSeller,
          this.fieldApplication,
          this.fieldCheckboxApplyAllApplications,
          this.fieldApplicationTags,
          this.fieldpreparationDays,
          this.labelFieldFile,
          this.fieldFile,
          this.fieldCheckboxIva,
          this.msgIva
        ]
      }
      else {
        this.form.seller = this.data.session.organization
        delete this.fieldApplication.dependency
        this.fields = [
          this.switchActive,
          this.fieldCountry,
          this.fieldApplication,
          this.fieldCheckboxApplyAllApplications,
          this.fieldApplicationTags,
          this.fieldpreparationDays,
          this.labelFieldFile,
          this.fieldFile,
          this.fieldCheckboxIva,
          this.msgIva
        ]
      }
      if (!this.data.isNew) {
        delete this.fieldFile.validation
        this.form.country = this.data.form.countryIdSeller
        this.form.switchActive = !!this.data.rates?.isActive
        this.form.seller = this.data.form.seller
        this.form.checkboxIva = !!(this.data.rates.iva === 1)
        this.form.preparationDays = this.data.rates.handlingTime
        this.valueTags = [this.data.form.application]
        this.fieldCountry.disabled = true
        this.fieldIdSeller.disabled = true
        this.fieldApplication.disabled = true
        this.fieldCheckboxApplyAllApplications.disabled = true
        this.form.iva = this.ivaValue[this.form.country.code]
        if (this.form.checkboxIva) {
          this.changeCheckboxIva('checkboxIva', this.form.checkboxIva)
        }
        this.checkValidation()
      } else {
        this.fieldCountry.disabled = false
        this.fieldIdSeller.disabled = false
        this.fieldApplication.disabled = false
        this.fieldCheckboxApplyAllApplications.disabled = false
        this.changeSeller('seller', this.data.session.organization)
        this.setCountryMkpEcc()
      }
      this.setMsgByType()
      this.ModalCustomCoverages++
    },
    setMsgByType() {
      if (this.data.isNew) {
        this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'switchActive') + 1, 0, this.msgNewTariff)
      } else {
        this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'switchActive'), 0, this.msgEditTariff)
      }
    },
    setCountryMkpEcc() {
      if (this.$session.get('cas_user').role === 'marketplace' || this.$session.get('cas_user').role === 'ecommerce') {
        this.form.country = this.$session.get('cas_user')?.country || null
        this.fieldCountry.disabled = true
      } else {
        delete this.form.country
        this.fieldCountry.disabled = false
      }
    },
    async setSeller(value) {
      const params = {
        country_id: this.form.country.id
      }
      const queryParams = {
        country_code: this.form.country.code,
        search: value,
        in_coverage: false
      }
      return await this.baseService.callService('getCompaniesCustomizedRates', queryParams, params)
        .then((resp) => resp.data.map((el) => ({ ...el, text: el?.name || 'Sin nombre' })))
        .catch((err) =>  err)
    },
    setOptions(fields, name, options) {
      if (this.m_getElementIndex(fields, 'name', name) !== -1) {
        this.fields[this.m_getElementIndex(fields, 'name', name)].options = options
        this.fields[this.m_getElementIndex(fields, 'name', name)].useSkeleton = false
      }
    },
    changeCountry(name, value) {
      this.form.iva = this.ivaValue[value.code]
      this.cleanFields(['seller', 'application'])
      this.cleanForm(['seller', 'application', 'allApplications', 'preparationDays', 'file', 'fileFreight', 'checkboxIva'])
    },
    changeSeller(name, value) {
      this.valueTags = []
      delete this.form.allApplications
      this.changeApplyAllApplications('allApplications', false)
      this.fields[this.m_getElementIndex(this.fields, 'name', 'application')].useSkeleton = true
      if (value?.id) {
        this.$store.dispatch('fetchService', { name: 'getApplications', queryParams: { company_id: value.id, in_coverage: false } })
      }
      if (!value) this.fields[this.m_getElementIndex(this.fields, 'name', 'application')].useSkeleton = false
    },
    changeSwitchActive(name, value) {
      this[name].options[0].text = value ? 'Activa' : 'Inactiva'
      this.formRenderCustomCoverages++
    },
    changeApplication(name, value) {
      if (value) {
        this.resetfieldApplication()
        this.fieldApplication.options = this.fieldApplication?.options?.filter(el => el.id !== value.id) || []
        this.valueTags.push(value)
        this.checkValidation()
        this.form[name] = undefined
      }
    },
    changeApplyAllApplications(name, value) {
      if (value) {
        this.fieldApplication.disabled = true
        this.valueTags = this.applications?.rows || []
      } else {
        this.fieldApplication.options = this.applications?.rows || []
        this.fieldApplication.disabled = false
        this.valueTags = []
      }
      this.checkValidation()
    },
    changeCheckboxIva(name, value) {
      if (value) {
        if (this.m_getElementIndex(this.fields, 'name', 'iva') === -1 && ['CL', 'CO', 'MX', 'PE'].includes(this.form.country.code)) {
          this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'checkboxIva') + 1, 0, this.fieldIva)
        }
      } else if (this.m_getElementIndex(this.fields, 'name', 'iva') !== -1) {
        this.fields.splice(this.m_getElementIndex(this.fields, 'name', 'iva'), 1)
      }
    },
    cleanFields(elements) {
      elements.forEach((el) => {
        this.fields[this.m_getElementIndex(this.fields, 'name', el)].useSkeleton = true
        setTimeout(() => {
          this.fields[this.m_getElementIndex(this.fields, 'name', el)].useSkeleton = false
        }, 100)
      })
    },
    cleanForm(elements) {
      elements.forEach((el) => {
        if (el === 'checkboxIva') this.changeCheckboxIva()
        delete this.form[el]
      })
      this.valueTags = []
      this.changeApplyAllApplications('allApplications', false)
    },
    checkValidation () {
      if (this.valueTags.length >= 1 && this.fieldApplication.validation === 'required') delete this.fieldApplication.validation
      if (this.valueTags.length === 0 && !(this.fieldApplication.validation)) this.fieldApplication.validation = 'required'
    },
    openModal() {
      this.isOpenModalDownLoadFormats = true
      this.$nextTick(() => {
        this.$bvModal.show('ModalDownLoadFormats')
        this.$refs.ModalDownLoadFormats.setInitialData()
      })
    },
    resetfieldApplication() {
      this.m_setSkeletonField(this.fields, 'name', 'application', true)
      setTimeout(() => {
        this.m_setSkeletonField(this.fields, 'name', 'application', false)
      }, 100)
    },
    removeTagApplication(index) {
      this.resetfieldApplication()
      this.fieldApplication.options = this.fieldApplication.options.concat(this.valueTags[index])
      this.valueTags.splice(index, 1)
      this.checkValidation()
    },
    async ok (e) {
      e.preventDefault()
      const check = await this.$refs.formRenderCustomCoverages.onlyCheckForm()
      if (check) this.sendForm()
    },
    sendForm() {
      const appsWithoutTariffs = []
      const appsNamesWithTariffs = []
      const appsIdsWithTariffs = []
      const formData = new FormData()
      if (!this.data.isNew) formData.append('to_replace', true)
      formData.append('is_active', !!(this.form.switchActive))
      if (this.form?.country?.code) formData.append('country_code', this.form.country.code)
      if (this.form?.seller?.id) formData.append('company_id', this.form.seller.id)
      if (this.form?.preparationDays) formData.append('preparation_days', this.form.preparationDays)
      formData.append('iva', !!this.form?.checkboxIva)
      if (this.form?.file) formData.append('file', this.form.file)
      if (this.valueTags.length) {
        this.valueTags.forEach(el => {
          if (el.has_customized_rates) {
            appsIdsWithTariffs.push(el.id)
            appsNamesWithTariffs.push(el.text)
          } else {
            appsWithoutTariffs.push(el.id)
          }
        })
      }
      if (appsIdsWithTariffs.length && this.data.isNew) {
        const confirmTitle = 'Tarifas existentes'
        const confirmMsg = `<p>Hemos detectado tarifas de <span style="font-weight: 700;">${appsNamesWithTariffs.join(', ')}</span> en plataforma. ¿Qué desea hacer para esta aplicación?</p>`
        const confirmSuccess = () => {
          if (appsWithoutTariffs.length) {
            appsWithoutTariffs.forEach(el => {
              formData.append('apps', el)
            })
          }
          if (appsIdsWithTariffs.length) {
            appsIdsWithTariffs.forEach(el => {
              formData.append('has_coverage', el)
            })
          }
          this.sendData(formData)
        }
        const onClose = () => {
          if (appsWithoutTariffs.length) {
            appsWithoutTariffs.forEach(el => {
              formData.append('apps', el)
            })
            this.sendData(formData)
          }
        }
        this.$confirm(confirmMsg, confirmSuccess, confirmTitle, 'Remplazar tarifas', 'Descartar cambios', true, onClose)
      } else if (appsWithoutTariffs.length && this.data.isNew) {
        appsWithoutTariffs.forEach(el => {
          formData.append('apps', el)
        })
        this.sendData(formData)
      } else if (!this.data.isNew) {
        appsIdsWithTariffs.forEach(el => {
          formData.append('apps', el)
        })
        this.sendData(formData)
      }
    },
    sendData(data) {
      const title = this.data.isNew ? `Tarifa propia ${this.$session.get('cas_user').role === 'admin' ? this.form.seller.name : ''} cargada con éxito!` : 'Procesando nueva tarifa!'
      this.loading.updatingData = true
      const serviceName = this.data.isNew ? 'postCustomizedRates' : 'putCustomizedRates'
      this.baseService
        .callUploadFileFormData(serviceName, data)
        .then((resp) => {
          this.$newSuccess(title, resp.message, 'large')
          if (!this.data.isNew) this.$emit('getRates', {isEdit: true, isDelete: false})
        })
        .catch((err) => {
          this.$newError('Ocurrio un error.', err.message, 'large')
          this.loading.updatingData = false
        })
        .finally(() => {
          this.loading.updatingData = false
          this.close()
        })
    },
    close() {
      this.cleanForm(['country', 'seller', 'application', 'allApplications', 'preparationDays', 'file', 'fileFreight', 'checkboxIva'])
      this.$bvModal.hide('ModalCustomCoverages')
    }
  }
}
</script>

<style lang="scss">
.msg-custom-coverage {
  font-size: 12px;
  align-content: center;
  margin-bottom: 0.5rem;
}
.msg-custom-coverage > span {
  margin-left: 0.5rem !important;
}
.badge__cnt{
  margin: 5px;
  background:#1B4284;
  padding: 2px 5px;
  border-radius: 1rem;
  padding-left: 1rem;
}
.color_icon{ //color para el icono X de los tags
  stroke: white;
}
</style>